import * as R from "ramda";
import { createSelector } from "reselect";
import { getFontCssName, resolveFontCss } from "utils/resolve-font-css";
import { getLoginStyles } from "redux/modules/portal/selectors";

/**
 * Styles
 */
export const getLogoImageUrl = createSelector(
  getLoginStyles,
  R.prop("logo_image_url")
);
export const getBackgroundImageUrl = createSelector(
  getLoginStyles,
  R.prop("background_image_url")
);
export const getLogoImageAltText = createSelector(
  getLoginStyles,
  R.prop("logo_alt_text")
);
export const getBackgroundImageAltText = createSelector(
  getLoginStyles,
  R.prop("background_image_url_alt_text")
);
export const getButtonColor = createSelector(
  getLoginStyles,
  R.prop("button_color")
);
export const getButtonTextColor = createSelector(
  getLoginStyles,
  R.prop("button_text_color")
);
export const getBackgroundColor = createSelector(
  getLoginStyles,
  R.prop("background_color")
);
export const getWelcomeMessageFont = createSelector(
  getLoginStyles,
  R.compose(getFontCssName, R.prop("welcome_message_font"))
);
export const getWelcomeMessageSize = createSelector(
  getLoginStyles,
  R.compose(size => (size ? `${size}px` : null), R.prop("welcome_message_size"))
);
export const getWelcomeMessageColor = createSelector(
  getLoginStyles,
  R.prop("welcome_message_color")
);
export const getWelcomeMessageText = createSelector(
  getLoginStyles,
  R.prop("welcome_message_text")
);
export const getCssCode = createSelector(getLoginStyles, styles => {
  let css = "";

  const fonts = R.compose(
    R.uniq,
    R.filter(f => f)
  )([styles.welcome_message_font]);

  const fontCss = resolveFontCss({ fonts });
  if (fontCss && fontCss.length) {
    css = `${fontCss}`;
  }

  if (styles.css_code && styles.css_code.length) {
    css = `${css} 

${styles.css_code}`;
  }

  return css;
});
